import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=bad23fe8&scoped=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=ts"
export * from "./NotFoundPage.vue?vue&type=script&lang=ts"
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&id=bad23fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad23fe8",
  null
  
)

export default component.exports